var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-module-wrap"},[_vm._v("\n  本地开发时,请手动编辑添加Session12\n")])}
var staticRenderFns = []

export { render, staticRenderFns }